export default __webpack_public_path__ + "static/media/map_logo.1e7f6bfe.svg";